import {State} from '../types/state'

export const hasAgreedWithPolicies = (state: State) => state.policies.agreed

export const hasPolicies = (state: State) => Boolean(getPolicies(state)?.length)

export const getPolicies = (state: State) => state.policies.policies

export const shouldShowAlert = (state: State) => state.policies.showAlert
